import { normalizeRole } from './permissions'

/**
 * Ops / manager home roles (full dashboard). Everyone else with a field
 * dashboard uses the crew/field home experience.
 */
export function usesOpsDashboard(role: string | undefined, isSuperAdmin = false): boolean {
  if (isSuperAdmin) return true
  const r = normalizeRole(role)
  return (
    r === 'admin' ||
    r === 'office' ||
    r === 'field_manager' ||
    r === 'crew_leader'
  )
}

/** Crew / QC-style field home — limited More menu + scoped properties. */
export function usesFieldHome(role: string | undefined, isSuperAdmin = false): boolean {
  if (isSuperAdmin) return false
  return !usesOpsDashboard(role, isSuperAdmin)
}

/** Deep-link target for property detail from jobs / More. */
export function propertyDetailPath(propertyId: string, fieldHome: boolean): string {
  return fieldHome ? `/my-properties/${propertyId}` : `/properties/view/${propertyId}`
}
